var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.33366 10.0001H9.83366V12.5001C9.83366 13.5134 9.01366 14.3334 8.00033 14.3334H4.00033C2.98699 14.3334 2.16699 13.5134 2.16699 12.5001V4.50008C2.16699 3.48675 2.98699 2.66675 4.00033 2.66675H8.00033C9.01366 2.66675 9.83366 3.48675 9.83366 4.50008V7.00008H5.33366C4.50699 7.00008 3.83366 7.67341 3.83366 8.50008C3.83366 9.32675 4.50699 10.0001 5.33366 10.0001ZM13.687 8.14675L11.687 6.14675C11.5932 6.05295 11.466 6.00025 11.3333 6.00025C11.2007 6.00025 11.0735 6.05295 10.9797 6.14675C10.8859 6.24055 10.8332 6.36776 10.8332 6.50041C10.8332 6.63307 10.8859 6.76028 10.9797 6.85408L12.1263 8.00075H5.33366C5.20105 8.00075 5.07387 8.05343 4.98011 8.14719C4.88634 8.24096 4.83366 8.36814 4.83366 8.50075C4.83366 8.63336 4.88634 8.76053 4.98011 8.8543C5.07387 8.94807 5.20105 9.00075 5.33366 9.00075H12.1263L10.9797 10.1474C10.8885 10.2417 10.8381 10.368 10.8392 10.499C10.8402 10.6301 10.8928 10.7556 10.9854 10.8483C11.0781 10.9411 11.2035 10.9937 11.3346 10.9949C11.4657 10.9961 11.592 10.9458 11.6863 10.8547L13.6863 8.85475C13.7328 8.80831 13.7696 8.75318 13.7948 8.6925C13.8199 8.63181 13.8329 8.56677 13.8329 8.50108C13.8329 8.43539 13.8199 8.37035 13.7948 8.30967C13.7696 8.24898 13.7328 8.19385 13.6863 8.14741L13.687 8.14675Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.028ca7abcc95cc83db29269af2d7aacd.svg";
export { ForwardRef as ReactComponent };